import AxiosConfig from '@/config/axios-config'

export const CupomAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/cupons',
      {
        params: {
          page: pagina,
          codigo: filtro.codigo,
          tipo_cupom_id: filtro.tipo_cupom_id,
          validade: filtro.validade,
          criado_em_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
          criado_em_fim: filtro.createdDate ? filtro.createdDateRange.endDate : '',
          data_fim_validade_inicio: filtro.validDate ? filtro.validDateRange.startDate : '',
          data_fim_validade_fim: filtro.validDate ? filtro.validDateRange.endDate : ''
        }
      }).then(response => response.data.cupons)
  },

  salvar (cupom) {
    return AxiosConfig.secureJalekoAPI().post('/admin/cupons', cupom).then(response => response.data)
  },

  importarCupons (arquivo, cupomPublico) {
    let formData = new FormData()
    formData.append('file', arquivo)
    cupomPublico.publicoAlvoCupons.periodicidade.forEach((item) => { if (item.checked) { formData.append('periodicidade[]', JSON.stringify(item)) } })
    cupomPublico.publicoAlvoCupons.planosMacro.forEach((item) => { if (item.checked) { formData.append('planosMacro[]', JSON.stringify(item)) } })
    cupomPublico.publicoAlvoCupons.planosMacroRequired.forEach((item) => { if (item.checked) { formData.append('planosMacroRequired[]', JSON.stringify(item)) } })
    return AxiosConfig.secureJalekoAPI().post('/admin/cupons/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  obterStatusImportacaoCupons () {
    return AxiosConfig.secureJalekoAPI().get('/admin/cupons/upload/status').then(response => response.data)
  },

  editar (cupom) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/cupons/${cupom.id}`, cupom).then(response => response.data)
  },

  deletar (cupom) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/cupons/${cupom.id}`, cupom).then(response => response.data)
  },

  listarTipos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/cupons/tipo').then(response => response.data.tipos_cupons)
  },

  async listarPublicoAlvoCupons () {
    let response = await AxiosConfig.secureJalekoAPI().get('/admin/cupons/publico-alvo')
    return response.data.publico_alvo
  }

}

export default CupomAPI
